<template>
  <div class="privacy-policy max-w-4xl mx-auto">
    <div class="glass-card p-8">
      <!-- 헤더 -->
      <div class="text-center mb-8">
        <div class="text-4xl mb-3">🔒</div>
        <h1 class="text-3xl font-bold text-gradient mb-2">개인정보처리방침</h1>
        <p class="text-gray-600">최종 수정일: 2025년 1월 29일</p>
      </div>

      <!-- 본문 -->
      <div class="space-y-8 text-gray-700">
        <!-- 1. 개인정보의 처리 목적 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">1. 개인정보의 처리 목적</h2>
          <div class="bg-blue-50 p-4 rounded-lg">
            <p class="mb-3">
              Lotto Genius('https://lottogenius.s2jlabs.com' 이하 '로또 지니어스')는 다음의 목적을 위하여 개인정보를 처리합니다. 
              처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 
              「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li><strong>서비스 제공:</strong> 로또 번호 생성, 통계 분석, 히스토리 조회 등 웹사이트 기본 기능 제공</li>
              <li><strong>서비스 개선:</strong> 사용자 경험 개선 및 신규 기능 개발을 위한 통계 분석</li>
              <li><strong>고객 지원:</strong> 문의사항 및 불만 처리, 공지사항 전달</li>
            </ul>
          </div>
        </section>

        <!-- 2. 개인정보 수집 항목 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">2. 수집하는 개인정보 항목</h2>
          <div class="bg-gray-50 p-4 rounded-lg space-y-3">
            <div>
              <h3 class="font-bold text-lg mb-2">가. 자동으로 수집되는 정보</h3>
              <ul class="list-disc list-inside space-y-1 ml-4">
                <li>방문 일시, 서비스 이용 기록</li>
                <li>IP 주소, 쿠키, 브라우저 정보</li>
                <li>기기 정보 (운영체제, 화면 크기 등)</li>
                <li>접속 로그, 페이지뷰</li>
              </ul>
            </div>
            <div>
              <h3 class="font-bold text-lg mb-2">나. 선택적으로 수집되는 정보</h3>
              <ul class="list-disc list-inside space-y-1 ml-4">
                <li>문의 시 제공하는 이메일 주소</li>
                <li>문의 내용</li>
              </ul>
            </div>
            <div class="bg-yellow-50 p-3 rounded border border-yellow-200">
              <p class="text-sm">
                <strong>💡 중요:</strong> 로또 지니어스는 회원가입을 요구하지 않으며, 이름, 주민등록번호, 전화번호 등의 
                민감한 개인정보를 수집하지 않습니다.
              </p>
            </div>
          </div>
        </section>

        <!-- 3. Google Analytics 및 광고 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">3. 쿠키 및 분석 도구 사용</h2>
          <div class="bg-purple-50 p-4 rounded-lg space-y-3">
            <div>
              <h3 class="font-bold text-lg mb-2">가. Google Analytics</h3>
              <p class="mb-2">
                본 사이트는 서비스 개선을 위해 Google Analytics를 사용합니다. Google Analytics는 쿠키를 통해 
                사용자의 웹사이트 이용 정보를 수집하며, 수집된 정보는 익명화되어 통계 목적으로만 사용됩니다.
              </p>
              <ul class="list-disc list-inside space-y-1 ml-4 text-sm">
                <li>페이지 조회수 및 방문 시간</li>
                <li>사용자 위치 (국가/도시 수준)</li>
                <li>사용 기기 및 브라우저 정보</li>
                <li>유입 경로 및 검색 키워드</li>
              </ul>
            </div>
            <div>
              <h3 class="font-bold text-lg mb-2">나. Google AdSense</h3>
              <p class="mb-2">
                본 사이트는 Google AdSense를 통해 광고를 게재합니다. Google 및 제3자 광고 제공업체는 쿠키를 사용하여 
                사용자의 관심사에 맞는 광고를 표시할 수 있습니다.
              </p>
              <ul class="list-disc list-inside space-y-1 ml-4 text-sm">
                <li>광고 표시 및 클릭 추적</li>
                <li>맞춤 광고 제공</li>
                <li>광고 사기 방지</li>
              </ul>
            </div>
            <div class="bg-blue-50 p-3 rounded">
              <p class="text-sm mb-2">
                <strong>쿠키 거부 방법:</strong>
              </p>
              <ul class="list-disc list-inside space-y-1 ml-4 text-sm">
                <li>브라우저 설정에서 쿠키를 차단하거나 삭제할 수 있습니다</li>
                <li>Google 광고 설정: <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener" class="text-blue-600 underline">https://www.google.com/settings/ads</a></li>
                <li>NAI 옵트아웃: <a href="http://www.networkadvertising.org/choices/" target="_blank" rel="noopener" class="text-blue-600 underline">http://www.networkadvertising.org/choices/</a></li>
              </ul>
            </div>
          </div>
        </section>

        <!-- 4. 개인정보의 보유 및 이용기간 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">4. 개인정보의 보유 및 이용기간</h2>
          <div class="bg-green-50 p-4 rounded-lg">
            <p class="mb-3">
              로또 지니어스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 
              동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
            </p>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li><strong>서비스 이용 기록:</strong> 3개월 (통계 분석 후 삭제)</li>
              <li><strong>쿠키:</strong> 브라우저 종료 시 또는 사용자가 삭제할 때까지</li>
              <li><strong>문의 기록:</strong> 문의 처리 후 1년 (법적 분쟁 대응)</li>
            </ul>
          </div>
        </section>

        <!-- 5. 개인정보의 제3자 제공 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">5. 개인정보의 제3자 제공</h2>
          <div class="bg-red-50 p-4 rounded-lg">
            <p class="mb-3">
              로또 지니어스는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 
              정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 
              개인정보를 제3자에게 제공합니다.
            </p>
            <div class="bg-white p-3 rounded">
              <p class="font-bold mb-2">현재 제3자 제공 현황:</p>
              <ul class="list-disc list-inside space-y-1 ml-4">
                <li><strong>Google (Analytics, AdSense):</strong> 위 3항 참조</li>
                <li><strong>기타 제3자:</strong> 해당 없음</li>
              </ul>
            </div>
          </div>
        </section>

        <!-- 6. 개인정보처리의 위탁 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">6. 개인정보처리의 위탁</h2>
          <div class="bg-gray-50 p-4 rounded-lg">
            <p class="mb-3">
              로또 지니어스는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
            </p>
            <table class="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr class="bg-gray-200">
                  <th class="border border-gray-300 p-2">수탁업체</th>
                  <th class="border border-gray-300 p-2">위탁업무 내용</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-gray-300 p-2">Cloudflare</td>
                  <td class="border border-gray-300 p-2">웹 호스팅 및 CDN 서비스</td>
                </tr>
                <tr>
                  <td class="border border-gray-300 p-2">Google LLC</td>
                  <td class="border border-gray-300 p-2">웹사이트 분석 및 광고 서비스</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <!-- 7. 정보주체의 권리·의무 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">7. 정보주체의 권리·의무 및 행사방법</h2>
          <div class="bg-indigo-50 p-4 rounded-lg">
            <p class="mb-3">
              정보주체는 로또 지니어스에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
            </p>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li>개인정보 열람 요구</li>
              <li>오류 등이 있을 경우 정정 요구</li>
              <li>삭제 요구</li>
              <li>처리정지 요구</li>
            </ul>
            <p class="mt-3 text-sm">
              권리 행사는 「개인정보 보호법」 시행규칙 별지 제8호 서식에 따라 서면, 전자우편 등을 통하여 
              하실 수 있으며, 로또 지니어스는 이에 대해 지체 없이 조치하겠습니다.
            </p>
          </div>
        </section>

        <!-- 8. 개인정보의 파기 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">8. 개인정보의 파기</h2>
          <div class="bg-orange-50 p-4 rounded-lg">
            <p class="mb-3">
              로또 지니어스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 
              지체없이 해당 개인정보를 파기합니다.
            </p>
            <div>
              <h3 class="font-bold mb-2">가. 파기절차</h3>
              <p class="text-sm mb-3">
                불필요한 개인정보는 개인정보보호 책임자의 승인을 받아 파기합니다.
              </p>
              <h3 class="font-bold mb-2">나. 파기방법</h3>
              <ul class="list-disc list-inside space-y-1 ml-4 text-sm">
                <li>전자적 파일: 복구 불가능한 방법으로 영구 삭제</li>
                <li>기록물, 인쇄물: 분쇄 또는 소각</li>
              </ul>
            </div>
          </div>
        </section>

        <!-- 9. 개인정보 보호책임자 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">9. 개인정보 보호책임자</h2>
          <div class="bg-blue-50 p-4 rounded-lg">
            <p class="mb-3">
              로또 지니어스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 
              정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
            </p>
            <div class="bg-white p-4 rounded space-y-2">
              <p><strong>개인정보 보호책임자</strong></p>
              <p>성명: 운영팀</p>
              <p>연락처: 하단 문의하기 페이지 참조</p>
            </div>
          </div>
        </section>

        <!-- 10. 개인정보 처리방침 변경 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">10. 개인정보 처리방침의 변경</h2>
          <div class="bg-gray-50 p-4 rounded-lg">
            <p>
              이 개인정보 처리방침은 2025년 1월 29일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 
              정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
            </p>
          </div>
        </section>

        <!-- 법적 고지 -->
        <section class="mt-8 pt-6 border-t border-gray-300">
          <div class="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
            <h3 class="font-bold mb-2 text-yellow-800">📋 법적 고지</h3>
            <p class="text-sm text-yellow-700">
              본 개인정보처리방침은 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 
              관련 법령을 준수하여 작성되었습니다. 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 
              아래 기관에 문의하시기 바랍니다.
            </p>
            <ul class="list-disc list-inside space-y-1 ml-4 text-sm mt-2 text-yellow-700">
              <li>개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
              <li>개인정보분쟁조정위원회 (www.kopico.go.kr / 1833-6972)</li>
              <li>대검찰청 사이버범죄수사단 (www.spo.go.kr / 국번없이 1301)</li>
              <li>경찰청 사이버안전국 (cyberbureau.police.go.kr / 국번없이 182)</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
// 스크립트가 필요하면 추가
</script>

<style scoped>
.text-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.glass-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
}

section {
  scroll-margin-top: 100px;
}

a {
  word-break: break-all;
}
</style>
